import authSdk from '../sdk'

/**
 * Client riêng cho báo cáo WAF FREE. Gọi thẳng servicemgmt v3
 * (`APP_SERVICE_API_V3_URL`) ở mọi môi trường.
 */
const wafReport = authSdk.createAxiosInstance({
    baseURL: import.meta.env.APP_SERVICE_API_V3_URL,
})

export default wafReport
